import React, { forwardRef, useMemo } from 'react';
import { useSurveyFormatContext } from '../useSurveyFormatContext';
import { SurveyFormatViewProps } from '../types';
import useFormatView from './useFormatView';

export function ClassicFormatView(
  { name, noShield, className, autoPadding, children, ...props }: SurveyFormatViewProps,
  forwardedRef?: React.Ref<HTMLDivElement>
): React.ReactElement {
  const formatContext = useSurveyFormatContext();
  const { ref } = useFormatView(name, formatContext, forwardedRef);
  const viewRenderProps = useMemo(() => ({ isActive: true, setNextActive: () => {} }), []);

  let content = children;
  if (typeof children === 'function') {
    content = children(viewRenderProps);
  }

  return (
    <div className={className} {...props} ref={ref}>
      {content}
    </div>
  );
}

export default forwardRef<HTMLDivElement, SurveyFormatViewProps>(ClassicFormatView);
